import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import userSystemApi from "../api/userSystemApi";
// create slice

const name = "userSystem";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const userActions = { ...slice.actions, ...extraActions };
export const userSystemReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    userSystems: [],
    totalCount: 0,
  };
}

function createExtraActions() {
  return {
    getAll: getAll(),
  };

  function getAll() {
    return createAsyncThunk(
      `${name}/getAll`,
      async (params) => await userSystemApi.getAll(params)
    );
  }
}

function createExtraReducers() {
  return {
    ...getAll(),
  };

  function getAll() {
    const { pending, fulfilled, rejected } = extraActions.getAll;
    return {
      [pending]: (state) => {
        // state.userSystems = { loading: true };
        state.userSystems = [];
      },
      [fulfilled]: (state, action) => {
        state.userSystems = action.payload?.results;
        state.totalCount = action.payload?.totalResults;
      },
      [rejected]: (state, action) => {
        // state.userSystems = { error: action.error };
        state.userSystems = [];
      },
    };
  }
}
